import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

export default function Activity(props) {
	const { i18NJson: i18n } = useStaticQuery(graphql`
		query {
			i18NJson {
				ui {
					loading
				}
			}
		}
	`);
	return (
		<div className="activity">
			<div className="icon">
				<div className="loader-inner ball-clip-rotate-multiple">
					<div></div>
					<div></div>
				</div>
			</div>
			<div className="text">{props.text ?? i18n.ui.loading}</div>
		</div>
	);
}
